import { useActionListContext } from 'ActionListContext';
import type { VariantProps } from 'class-variance-authority';
import { useCallback } from 'react';
import type { CommandGroupItemProps } from 'types';
import type { commandItemVariants } from 'variants/item-variants';

import { CommandItem } from './CommandItem';

const getItemState = (
  isSelected: boolean,
  isDisabled?: boolean,
  isReadOnly?: boolean,
): VariantProps<typeof commandItemVariants>['state'] => {
  if (isSelected) {
    return 'selected';
  }

  if (isDisabled) {
    return 'disabled';
  }

  if (isReadOnly) {
    return 'readOnly';
  }
};

export const CommandGroupItem: React.FC<CommandGroupItemProps> = ({
  isSelected,
  item,
  showSeparator,
  itemSize,
  showSelectionElement,
  isTruncated = false,
}) => {
  const { OptionComponent, onChange } = useActionListContext();

  const handleSelect = useCallback(() => {
    if (item.readOnly) {
      return undefined;
    }

    onChange(item.value);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [item.readOnly, onChange]);

  return (
    <>
      <CommandItem
        size={itemSize}
        disabled={item.disabled}
        isSelected={isSelected}
        state={getItemState(isSelected, item.disabled, item.readOnly)}
        aria-readonly={item.readOnly}
        data-testid={`item-${item.value}`}
        value={item.value}
        onSelect={handleSelect}
      >
        <OptionComponent
          isSelected={isSelected}
          item={item}
          showSelectionElement={showSelectionElement}
          isTruncated={isTruncated}
        />
      </CommandItem>
      {showSeparator ? (
        <div className="border-color-comp-table-divider my-2 border-b border-solid" />
      ) : null}
    </>
  );
};
